import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from '../assets/ForgotPassword.module.css';
import MultiStepTrackerWrapper from '../components/MultiStepTracker';

const { dlsBrightBlue, ButtonPrimary, Anchor, DialogBox, DialogBoxHeader, DialogBoxBody, IconTelephone, ButtonSecondary, IconEmail } = require('@americanexpress/dls-react');
const { FORGOT_PASSWORD_URL } = require('../helper/application-conf').default;



const ForgotEmailSuccess = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const emailId = location.state;
    const [successModalOpen, setSuccessModalOpen] = useState(false);

    return (
        <div className="container">
            <div className="row pad-tb">
                <div className="col-md-offset-3 col-md-6">
                    <MultiStepTrackerWrapper greyOut={true}/>
                </div>
            </div>
            <div className="row">
                <div className="col-md-offset-4 col-md-4">
                    <h5 className="heading-5 text-align-center pad-4-t">{t('login.email_success_header')}</h5>
                    <p className="pad-4-t">{t('login.instructions')}<span><b>{' ' + emailId}</b></span></p>
                </div>
            </div>
            <div className="row">
                <div className="flex flex-column col-md-offset-4 col-md-4 pad-1-b pad-2-t text-align-center">
                    <ButtonSecondary id="nomail-popup" onClick={() => { setSuccessModalOpen(true) }} className={`${styles.fluid}`}>
                        {t('login.no_mail')}
                    </ButtonSecondary>
                </div>
                <div className="flex flex-column col-md-offset-4 col-md-4 pad-1-b text-align-center">
                    <Anchor id="forgot-return-link" className="text-decoration-none" onClick={() => { navigate(FORGOT_PASSWORD_URL); }}>
                        {t('login.edit_email_address')}
                    </Anchor>
                </div>
            </div>
            {successModalOpen
                && (
                    <DialogBox onClose={() => { setSuccessModalOpen(false) }} id="success-modal">
                        <DialogBoxHeader id="success-modal-header">
                            <h2>{t('login.no_mail_header')}</h2>
                        </DialogBoxHeader>
                        <DialogBoxBody id="success-modal-body">
                            <p className='pad-1-t'>{t('login.verify_mail')}</p>
                            <p>{t('login.verify_mail_body_1')}</p>
                            <h4 className='pad-1-t'>{t('login.verify_mail_body_2')}</h4>
                            <div className='pad-2-t'>
                                <p><IconTelephone theme={dlsBrightBlue} className="pad-1-r" />{t('login.support_num')}</p>
                                <p><IconEmail theme={dlsBrightBlue} className="pad-1-r" />{t('login.support_email')}</p>
                            </div>
                            <ButtonPrimary size="sm" id="continue-button" onClick={() => { setSuccessModalOpen(false) }} className="margin-auto-lr margin-1-b margin-3-t">{t('Close')}</ButtonPrimary>
                        </DialogBoxBody>
                    </DialogBox>
                )}
        </div>
    );
};

export default ForgotEmailSuccess;